export default {
  error: undefined,
  loading: false,
  token: undefined,
  username: undefined,
  budgetDocument: undefined,
};
